export default __webpack_public_path__ + "static/media/logo-colored.6b24b9c4.svg";